



























































import moment from 'moment'
import japaneseHolidays from 'japanese-holidays'

export default
  props:
    leftSwitching:
      type: Boolean
      default: true
    rightSwitching:
      type: Boolean
      default: true
    halfWidth:
      type: Boolean
      default: false
    events:
      type: Array
      dafalt: []
    addDayOfWeek:
      type: Boolean
      default: false
    supplySourceNum:
      type: String
      default: ''
    user:
      type: Boolean
      default: false

  data: () ->
    month: moment().format('yyyy-MM-DD')
    nextMonth: moment().add('months', 1).format('yyyy-MM-DD')
    dayOfWeek: ''
    holidays: []
    event: []
    supplySource: ''
    weekdays: [1,2,3,4,5]

  watch: {
    month: (date) ->
      @nextMonth = moment(date).add('months', 1).format('yyyy-MM-DD')
    events: (v) ->
      @event = @holidays.concat(v)
    holidays: (v) -> 
      @event = v.concat(@events)
  }
  # 曜日のクリックイベントを付ける場合の為にコメントアウトしています。
  # mounted: () ->
  #   # 曜日がクリックされた時にその曜日を取得
  #   el = document.getElementsByClassName('v-calendar-weekly__head-weekday')
  #   els = Array.from(el)
  #   for row, index in els
  #     if @addDayOfWeek
  #       startDay = moment(@month).startOf('month').format('yyyy-MM-DD')
  #       endDay = moment(@month).endOf('month').format('yyyy-MM-DD')
  #       events = @events
  #       if !events
  #         events = []
  #       # クリックイベントを追加
  #       row.addEventListener('click', (e) ->
  #         moment.locale("ja")
  #         start = moment(startDay)
  #         end = moment(endDay)
  #         # 月初から月末までループを回す
  #         while(start.unix() <= end.unix())
  #           # クリックした曜日と同じか比較
  #           if  e.target.textContent == start.format('dd')
  #             if events.length != 0
  #               startTime = events.map (el) -> el.start
  #               startTimeIndex = startTime.indexOf(start.format('YYYY-MM-DD'))
  #               if startTimeIndex == -1
  #                 events.push(
  #                   name: '供給不可日'
  #                   start: start.format('YYYY-MM-DD')
  #                   end: start.format('YYYY-MM-DD')
  #                   color: 'red'
  #                   timed: false
  #                   supply_source: ''
  #                 )
  #             else
  #               events.push(
  #                 name: '供給不可日'
  #                 start: start.format('YYYY-MM-DD')
  #                 end: start.format('YYYY-MM-DD')
  #                 color: 'red'
  #                 timed: false
  #                 supply_source: ''
  #               )
  #           start.add(1, 'days')
  #         moment.locale("en")
  #       @events = events
  #       , false)

  computed: {
    title: () ->
      return moment(@month).format('yyyy年 M月')
    nextMonthTitle: () ->
      return moment(@nextMonth).format('yyyy年 M月')
  }

  methods: {
    getEventColor: (event) ->
      return event.color
    showEvent: (event) ->
      #イベントの内容が見れる
      # console.log event
    viewDay: (date) ->
      #クリックした日がわかる
      @$emit('click', date, @accept(date.date))
    getEvents: () ->
      #カレンダーが表示、切り替えると呼ばれる
      @$emit('change', @month)
    accept: (date) ->
      if @user
        for row, index in @events
          if row.start == date && row.name == '供給不可日'
              return false
          if row.start == date && row.color = 'blue'
            array = row.name.split(/[/件]/)
            if Number(array[0]) >= Number(array[1])
              return false
        return true
      else
        for row, index in @events
          if row.start == date && row.name == '供給不可日'
            return false
        return true
    returnDay: (timestamp) ->
      if moment(@month).isSame(new Date(timestamp.date), 'month')
        @addHolidays(timestamp)
        return new Date(timestamp.date).getDate()
      return ''
    returnNextMonthDay: (timestamp) ->
      if moment(@nextMonth).isSame(new Date(timestamp.date), 'month')
        @addHolidays(timestamp)
        return new Date(timestamp.date).getDate()
      return ''
    addHolidays: (timestamp) ->
      day = new Date(timestamp.date)
      if japaneseHolidays.isHoliday(day)
        name = @holidays.map (el) -> el.name
        index = name.indexOf(japaneseHolidays.isHoliday(day))
        if index < 0
          @holidays.push(
            name: japaneseHolidays.isHoliday(day)
            start: moment(day).format('yyyy-MM-DD')
            end: moment(day).format('yyyy-MM-DD')
            color: '#4B5459'
            timed: false
          )
    monthSwitching: () ->
      beginningDay = moment(@month).startOf('month').format('yyyy-MM-DD')
      endOfNextMonth = moment(@month).add('months', 1).endOf('month').format('yyyy-MM-DD')
      param =
        start: beginningDay
        end: endOfNextMonth
      @$emit('monthSwitching', param)
  }
